import classnames from 'classnames';
import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Card, Col, Container, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import Breadcrumb from '../../../components/Common/Breadcrumb';
import { SampleLaboratoryTable } from '../components/SampleLaboratoryTable';

export const LabRequestSampleView = (props) => {
    const citec = localStorage?.getItem("CITEC") ? JSON.parse(localStorage?.getItem("CITEC") ?? `{"labType": '1' }`) : '0'
    const movil = localStorage?.getItem("Movil") ? JSON.parse(localStorage?.getItem("Movil") ?? `{"lId": '1' }`) : '0'

    let [activeTab, setActiveTab] = useState('1');
    let [lab, setLab] = useState(citec);
    let [labName, setLabName] = useState('CITEC');

    const profiletoggle = tab => {
        if (activeTab !== tab) {
            activeTab = tab
            setActiveTab(activeTab);
        }
        if (activeTab === '1'){
            labName = 'CITEC'
            setLabName(labName)
            lab = citec
            setLab(lab)
        }
        else{
            labName = 'Móvil'
            setLabName(labName)
            lab = movil
            setLab(lab)
        }
    }

    return (
    <React.Fragment>
        <div className="page-content">
            <Container fluid className="" >
                <Col className="col-12" style={{ padding: 20 }}>
                    <Card className='' style={{ padding: 50 }}>
                        <Breadcrumb breadcrumbItem1='labCitec' breadcrumbItem2='labRequestSampleView' />
                        <Nav tabs className="d-flex nav-tabs-custom justify-content-start">
                            <NavItem className='px-5'>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({ active: activeTab === '1' })}
                                    onClick={() => { profiletoggle('1'); }}
                                >
                                    Control de Muestras - CITEC

                                </NavLink>
                            </NavItem>

                            <NavItem className='px-5'>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({ active: activeTab === '2' })}
                                    onClick={() => { profiletoggle('2'); }}
                                >
                                    Control de Muestras - Móvil

                                </NavLink>
                            </NavItem>
                        </Nav>

                        <TabContent activeTab={activeTab} className="p-3">
                            <TabPane tabId='1'>
                                <SampleLaboratoryTable props={props} lab={lab} labName={labName} />
                            </TabPane>
                            <TabPane tabId='2'>
                                <SampleLaboratoryTable props={props} lab={lab} labName={labName} />
                            </TabPane>
                        </TabContent>

                        <br />
                    </Card>
                </Col>
                <ToastContainer autoClose={2000} newestOnTop={true} />
            </Container>
        </div>
    </React.Fragment>
    )
}
